import * as FormConst from 'constants/FormConst'
import React, { Component } from 'react'
import { ProgressBar as ProgressBarComponent } from 'react-bootstrap'
import './ProgressBar.scss'

class ProgressBar extends Component {

    render() {
        return (
            <div className='progress-bar-component'>
                <label className='progress-bar-label'>
                    <b>Status: </b> {this.props.status ? FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[this.props.status] : ''}
                    <br className='d-xs-block d-md-none' />
                    <b className='ml-3'>Progress: </b>{this.props.now}%</label>
                <ProgressBarComponent className='progress-bar-display' {...this.props} />
            </div>
        )
    }
}

export default ProgressBar